import { createSlice } from '@reduxjs/toolkit';

export const sliceCalendar = (name, initialState) =>
  createSlice({
    name,
    initialState: { ...initialState },
    reducers: {
      sortCalendarChange: (state, action) => {
        state.sort = {
          by: action.payload?.by,
          direction: state.sort.direction === 'asc' ? 'desc' : 'asc',
        };
      },
    },
  });
